import { FieldError } from "react-hook-form";

/**
 * Check if the object is a FieldError
 *
 * Relies on the mandatory `type` property being present in FieldError.
 */
function isFieldError<T extends object>(t: T | FieldError): t is FieldError {
    return "type" in t;
}

/**
 * Workaround for field errors mistyping, when working with object values `fieldState.error` expose type `FieldError`,
 * but it can be `Record<string, FieldError>` as well.
 *
 * Returns either the `FieldError.message`, or the first message from the `Record<string, FieldError>`.
 *
 * Order of messages from record is not guaranteed.
 *
 * @param error
 */
export function extractNestedError(
    error?: FieldError | Record<string, FieldError>
): string | undefined {
    if (error === undefined) {
        return undefined;
    }
    if (isFieldError(error)) {
        return error.message;
    }
    // Find the first error message (unlikely to have more than one - RHF should promote one in that case)
    return Object.values(error)
        .map((e) => extractNestedError(e))
        .find((m) => m !== undefined);
}
